module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.field.label != null) ? _c('div', {
    staticClass: "u-color-secondary u-mt1 u-text-trim"
  }, [_vm._v(_vm._s(_vm.t(_vm.field.label)))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-mt2 u-text-multiline-trim"
  }, [_vm._v(_vm._s(_vm.field.value))])])
},staticRenderFns: []}